module.exports = "/assets/fonts/Montserrat-Regular.ttf";